/**
 * Rank codes in AFPC roster-export style. Used by the roster Add/Edit
 * Member form and the free-form guest tester form.
 */
export const RANK_OPTIONS: readonly string[] = [
  'AMN', 'A1C', 'SRA', 'SSG', 'TSG', 'MSG', 'SMS', 'CMS',
  '2LT', '1LT', 'CPT', 'MAJ', 'LTC', 'COL', 'BG', 'MG', 'LG', 'GEN',
  'CIV',
]
